export default __webpack_public_path__ + "images/812eedf108fdb30cb799c993ee2b9ca4-chevron-down.svg";